if (typeof (String.prototype.startsWith) === 'undefined') {
    String.prototype.startsWith = function (str) {
        return this.slice(0, str.length) === str;
    };
}

var isUndefined = function (str) {
    if (str == null || str == undefined || str == '') {
        return true;
    }
    else {
        return false;
    }
}

var removeByAttr = function (arr, attr, value) {
    var i = arr.length;
    while (i--) {
        if (arr[i]
            && arr[i].hasOwnProperty(attr)
            && (arguments.length > 2 && arr[i][attr] === value)) {

            arr.splice(i, 1);
        }
    }
    return arr;
}

var getByAttr = function (arr, attr, value) {
    var i = arr.length;
    while (i--) {
        if (arr[i] && arr[i].hasOwnProperty(attr) && (arguments.length > 2 && arr[i][attr] === value)) {
            return arr[i];
        }
    }
    return null;
}

function isValidDate(d) {
    if (Object.prototype.toString.call(d) !== "[object Date]")
        return false;
    return !isNaN(d.getTime());
}

function updateArray(array, object, remove) {
    var found = false;

    for (var i in array) {
        if (array[i].id == object.id) {
            found = true;
            if (remove) {
                array.splice(i, 1);
            }
            else {
                array[i] = angular.copy(object);
            }
        }
    }

    if (!found && !remove) {
        array.push(object);
    }
}

function sortObjectArray(property) {
    var sortOrder = 1;
    if (property[0] === "-") {
        sortOrder = -1;
        property = property.substr(1);
    }
    return function (a, b) {
        var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
        return result * sortOrder;
    }
}

function guid() {
    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    }
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
        s4() + '-' + s4() + s4() + s4();
}

function nullGuid() {
    return '00000000-0000-0000-0000-000000000000';
}

function isValidGuid(test) {
    var regex = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/i;
    var match = regex.exec(test);
    return match != null;
}

function isValidGuidList(list) {
    if (list === '' || (Array.isArray(list) && list.length === 0)) {
        return false;
    }
    var pass = true;
    list.split(',').forEach(function (test) {
        if (!isValidGuid(test)) {
            pass = false;
        }
    })

    return pass;
}

Date.prototype.revertTimeZone = function () {
    var showDate = new Date(this.getTime());
    showDate.setTime(showDate.getTime() + (showDate.getTimezoneOffset() * 60 * 1000));
    return showDate;
}

Date.prototype.applyTimeZone = function () {
    var showDate = new Date(this.getTime());
    showDate.setTime(showDate.getTime() - (showDate.getTimezoneOffset() * 60 * 1000));
    return showDate;
}

function validateEmail(email) {
    var re = /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$/;
    return re.test(email);
}

function isEmpty(obj) {
    for (var key in obj) {
        if (obj.hasOwnProperty(key))
            return false;
    }
    return true;
}

function isHexColor(color) {
    // used to see if input string is valid hex for color representation in CSS
    var re = /(^[0-9A-Fa-f]{6}$)|(^[0-9A-Fa-f]{3}$)/;
    return re.test(color);
}

function getNameFromListArray(array, id) {
    // returns the id if there is no matching id in the array
    var nameVal = null;
    if (angular.isArray(array)) {
        array.forEach(function (opt) {
            if (opt.id == id) {
                nameVal = opt.name;
            }
        })
    }
    return nameVal;
}


function generateStringFromArrays(valueArray, optionArray) {
    var showValue = null;

    if (angular.isArray(valueArray)) {
        valueArray.forEach(function (val) {
            if (val != null) {
                var value = null;
                if (angular.isString(val)) {
                    value = val;
                }
                else {
                    value = val.id;
                }

                optionArray.forEach(function (opt) {
                    if (opt.id == value) {
                        if (showValue == null) {
                            showValue = opt.name;
                        }
                        else {
                            showValue += ', ' + opt.name;
                        }
                    }
                })
            }
        })

        if (valueArray.length > 0 && showValue == null) {
            showValue = "";
        }
    }
    else if (angular.isString(valueArray)) {
        valueArray.split(',').forEach(function (val) {
            optionArray.forEach(function (opt) {
                if (opt.id == val) {
                    if (showValue == null) {
                        showValue = opt.name;
                    }
                    else {
                        showValue += ', ' + opt.name;
                    }
                }
            })
        })

        if (valueArray != null && valueArray != "" && showValue == null) {
            showValue = "";
        }
    }

    return showValue;
}

function chunkArray(myArray, chunk_size) {
    var results = [];

    while (myArray.length) {
        results.push(myArray.splice(0, chunk_size));
    }

    return results;
}